import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import {
    ChatInput,
    PreviewChatImg,
    RecievedMsg,
    SVG,
    SendedMsg,
    UserPopoverContainer
} from "ui";

import "assets/css/chat.css";
import { friendAvatar } from "utils/assets_exports/images";
import { chat_data } from "assets/data/chatData";
import { useEffect, useRef, useState } from "react";

const Chat = () => {
    const [msgs, setMsgs] = useState(chat_data);
    // const [newMsg, setNewMsg] =
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [showNotification, setShowNotification] = useState(false);

    const [showGoToBottom, setShowGoToBottom] = useState(false);

    const messagesEndRef = useRef<null | HTMLDivElement>(null);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const isElementInViewport = (el: HTMLElement | null): boolean => {
        if (!el) return false;
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    useEffect(() => {
        setTimeout(() => {
            scrollToBottom();
        }, 500);

        const handleScroll = () => {
            if (containerRef.current) {
                const { scrollTop, scrollHeight, clientHeight } =
                    containerRef.current;
                if (scrollTop + clientHeight === scrollHeight) {
                    setShowNotification(false);
                    setShowGoToBottom(false);
                } else if (scrollTop + clientHeight < scrollHeight - 100) {
                    // setShowNotification(true);
                    setShowGoToBottom(true);
                }
            }
        };

        const container = containerRef.current;
        container?.addEventListener("scroll", handleScroll);
        return () => {
            container?.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (isElementInViewport(messagesEndRef.current)) {
            scrollToBottom();
            setTimeout(() => {
                scrollToBottom();
            }, 500);
        } else {
            setShowNotification(true);
        }
    }, [msgs]);

    // add msgs
    const addMsg = (msg: string, type: "text" | "media") => {
        const d = new Date();
        const hours = d.getHours();
        const minutes = d.getMinutes();

        const time = `${hours}:${minutes}`;
        const id = "id" + Math.random().toString(16).slice(2);
        setMsgs([
            ...msgs,
            {
                id,
                msg: type == "text" ? msg : undefined,
                img: type == "media" ? msg : undefined,
                time,
                user: {
                    id: 5,
                    name: "Richard Kettleboroug",
                    username: "richard11",
                    url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
                },
                read: false,
                sended: true
            }
        ]);
    };
    // add recived msgs demo
    // const addDemoRecievedMsg = () => {
    //     const d = new Date();
    //     const hours = d.getHours();
    //     const minutes = d.getMinutes();

    //     const time = `${hours}:${minutes}`;
    //     const id = "id" + Math.random().toString(16).slice(2);
    //     setMsgs([
    //         ...msgs,
    //         {
    //             id,
    //             msg: "demo test",
    //             time,
    //             user: {
    //                 id: 8,
    //                 name: "Al Khaldi",
    //                 username: "alkhaldi",
    //                 url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
    //             },
    //             read: true,
    //             sended: false
    //         }
    //     ]);
    // };

    const [previewImg, setPreviewImg] = useState<string | undefined>(undefined);

    return (
        <FeedLayout pageTitle="">
            <div className="profile-followers-div">
                <div
                    className={`d-flex flex-j-between flex-a-center gap-10 w-full mb-30 mt-20`}
                >
                    <div>
                        <Link to="/chat">
                            <SVG svg="chevron-left" size={24} />
                        </Link>
                    </div>
                    <div className="d-flex flex-col flex-j-center flex-a-center">
                        <h1 className="fw-700 fs-12em">Dan Walker</h1>
                        <p className="online">Online</p>
                        <p className="blue-text">18 Dec, 2023</p>
                    </div>
                    <UserPopoverContainer className="myChatPopoverContainer right-popover">
                        <div className="p-relative">
                            <img
                                src={friendAvatar}
                                className="chat-page-top-img box-shadow"
                                alt="user image"
                            />
                        </div>
                    </UserPopoverContainer>
                </div>

                <div className="profile-followers-card card mt-20 chat-page-msgs-card d-flex flex-col gap-5 p-relative">
                    <div
                        className="d-flex flex-col gap-5 overflow-y-auto"
                        style={{ height: "90%" }}
                        ref={containerRef}
                    >
                        {msgs.map((msg) =>
                            msg.sended ? (
                                <SendedMsg
                                    msg={msg}
                                    key={msg.id}
                                    setPreviewImg={setPreviewImg}
                                />
                            ) : (
                                <RecievedMsg
                                    msg={msg}
                                    key={msg.id}
                                    setPreviewImg={setPreviewImg}
                                />
                            )
                        )}
                        <div ref={messagesEndRef} />
                    </div>
                    {showNotification ? (
                        <div
                            className="new-msg-noti box-shadow cursor-pointer"
                            onClick={scrollToBottom}
                        >
                            New message received
                        </div>
                    ) : (
                        showGoToBottom && (
                            <div
                                className="scroll-to-bottom-arrow svg-circle"
                                onClick={scrollToBottom}
                            >
                                <SVG
                                    svg="arrow-left"
                                    size={20}
                                    className="blue-svg arrow-down"
                                />
                            </div>
                        )
                    )}

                    <ChatInput addMsg={addMsg} />
                    {/* <div className="white-text" onClick={addDemoRecievedMsg}>
                        test
                    </div> */}
                    {previewImg && (
                        <PreviewChatImg
                            src={previewImg}
                            setPreviewImg={setPreviewImg}
                        />
                    )}
                </div>
            </div>
        </FeedLayout>
    );
};
export default Chat;
